<script lang="ts">
	export let content: string;
</script>

<meta name="description" {content} />
<meta property="og:description" {content} />
<meta property="twitter:description" {content} />
